import { render, staticRenderFns } from "./cv-side-nav-link.vue?vue&type=template&id=5a4d15be&"
import script from "./cv-side-nav-link.vue?vue&type=script&lang=js&"
export * from "./cv-side-nav-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports